// ABOUTME: 404 Not Found page component.
// ABOUTME: Displays error message and navigation back to home.

import { useNavigate } from 'react-router-dom';
import { Home, AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="h-full flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 rounded-sm bg-error-light flex items-center justify-center mx-auto mb-6">
          <AlertTriangle className="w-10 h-10 text-error" />
        </div>
        <h1 className="text-4xl font-bold text-surface-800 mb-2">
          404
        </h1>
        <h2 className="text-xl font-medium text-surface-800 mb-3">
          Page Not Found
        </h2>
        <p className="text-surface-600 mb-6">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Button onClick={() => navigate('/')} leftIcon={<Home className="w-4 h-4" />}>
          Back to Home
        </Button>
      </div>
    </div>
  );
}
